module.exports = __webpack_public_path__ + "static/media/card-Visa-mobile-inactive.6c28e76a.svg";